import styled from "styled-components";
import { flexbox, layout, space, grid } from "styled-system";
export const Box = styled.div`
	${layout}
	${flexbox}
    ${grid}
    ${space}
`;
